import { RecipeBoxDataGateway } from '../../providers/recipe-box-data-gateway';
import { LocalRecipeBoxData } from '../../providers/local-recipe-box-data';
import { ElasticSearchService } from '../../../../providers/elastic-search';
import { Component } from '@angular/core';
import { UserData } from '../../../../providers/user-data';
import { Events, LoadingController, NavController, NavParams } from 'ionic-angular';
import { PageBase } from '../../../../core/page-base';
import { AppSettings } from '../../../../config/app-settings';
import { RecipeDetailPage } from '../../pages/recipe-detail/recipe-detail';
import { RecipeBoxesCommon } from './recipe-boxes.common';
import { RecipeData } from '../../providers/recipe-data';
//import firebase from 'firebase';
@Component({
  selector: 'recipe-boxes',
  templateUrl: 'recipe-boxes.html'
})
export class RecipeBoxesPage extends PageBase {
  public userRecipes = [];
  public loader: any;
  public pagedFilteredItems: any = [];
  public pageSize: number = 2;
  public hasMore = true;
  public isFavorite = true;
  categoryId = '';
  category: any;
  recipeBoxData: any;
  userId = '';
  public isLoading = false;

  constructor(public nav: NavController,
    public userData: UserData,
    public settings: AppSettings,
    public events: Events,
    public common: RecipeBoxesCommon,
    private navParams: NavParams,
    public recipeData: RecipeData,
    public loadingCtrl: LoadingController,
    public elasticSearchService: ElasticSearchService,
    public localRecipeBox: LocalRecipeBoxData,
    public recipeBoxGateway: RecipeBoxDataGateway) {
    super(settings, events, nav, userData);

    this.userRecipes = this.navParams.get('recipes');
    this.category = this.navParams.get('category');
  }
  ngAfterViewInit() {

  }

  loadPage() {
    this.isLoading = true;
    let start: number = this.pagedFilteredItems.length;
    let pageItems = _.slice(this.userRecipes, start, start + this.pageSize);
    Array.prototype.push.apply(this.pagedFilteredItems, pageItems);
    this.hasMore = this.pagedFilteredItems.length < this.userRecipes.length;
    this.isLoading = false;
  }
  loadMoreItems(infiniteScroll) {
    if (this.isLoading) {
      return;
    }
    this.loadPage();
    infiniteScroll.complete();
  }

  viewRecipeDetail(recipe) {
    this.nav.push(RecipeDetailPage, { id: recipe.$id ? recipe.$id : recipe.$key });
  }

  loadData() {
    this.userRecipes = [];
    this.hasMore = true;
    this.pagedFilteredItems = [];
    this.loader.present();
    this.userRecipes = this.navParams.get('recipes');
    // this.category = this.navParams.get('category');
    this.loadPage();
    this.loader.dismiss();
  }

  selectFavorite(recipe) {
    if (!recipe.isFavorite) {
      this.recipeBoxData.add(this.userId, recipe).then(userRecipe => {
        recipe.isFavorite = true;
      });
    }
    else {
      recipe.isFavorite = false;
      this.recipeBoxData.remove(this.userId, recipe).then(result => {
        if (result)
          recipe.isFavorite = false;
      });
    }
  }



  ionViewDidEnter() {
    this.loader = this.loadingCtrl.create();
    this.userId = this.currentUser ? this.currentUser.uid : '';
    this.recipeBoxData = this.recipeBoxGateway.getService(this.userId);
    this.loadData();
  }

}


// WEBPACK FOOTER //
// ./src/modules/recipes/pages/recipe-boxes/recipe-boxes.ts